/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ExternalPartiesDTO } from '../models/ExternalPartiesDTO';
import type { ExternalPartyChangesRequestDTO } from '../models/ExternalPartyChangesRequestDTO';
import type { LocalPartyListingDTO } from '../models/LocalPartyListingDTO';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class LocalPartyControllerService {
    /**
     * @param name
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static getExternalPartyChanges(
        name: string,
        requestBody: ExternalPartyChangesRequestDTO,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/participants/{name}/parties/local/external/changes',
            path: {
                'name': name,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                409: `The changes can't be read from the cursor: reason CURSOR_INVALID, PARTICIPANT_CHANGED or SYNCHRONIZERS_CHANGED`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param name
     * @returns LocalPartyListingDTO OK
     * @throws ApiError
     */
    public static getLocalParties(
        name: string,
    ): CancelablePromise<LocalPartyListingDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/participants/{name}/parties/local',
            path: {
                'name': name,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param name
     * @returns ExternalPartiesDTO Keep-alive comments, then a result or an error event
     * @throws ApiError
     */
    public static scanExternalParties(
        name: string,
    ): CancelablePromise<ExternalPartiesDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/participants/{name}/parties/local/external',
            path: {
                'name': name,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Participant not found: an error event`,
                500: `Any other failure, e.g. the Kubernetes API: an error event`,
                503: `Participant unreachable or not connected: an error event`,
            },
        });
    }
}
